import { render, staticRenderFns } from "./ComShopLocation.vue?vue&type=template&id=a2b5b49e&scoped=true&"
import script from "./ComShopLocation.vue?vue&type=script&lang=js&"
export * from "./ComShopLocation.vue?vue&type=script&lang=js&"
import style0 from "./ComShopLocation.vue?vue&type=style&index=0&id=a2b5b49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b5b49e",
  null
  
)

export default component.exports